export default "__VITE_ASSET__CdPjw3Oq__"